<template>
    <div class="d-flex buttons-wrapper">
        <b-button variant="default" @click="$bvModal.show(holidaysModalId)">
            <font-awesome-icon :icon="['fas', 'bars']" />
        </b-button>
        <b-button variant="default" @click="$bvModal.show(editCalendarModalId)">
            <font-awesome-icon :icon="['fas', 'pen-to-square']" />
        </b-button>
        <b-button
            variant="default"
            @click="$bvModal.show(deleteCalendarModalId)"
        >
            <font-awesome-icon :icon="['fas', 'trash']" />
        </b-button>
        <modal
            :id="deleteCalendarModalId"
            title="Delete Calendar"
            @ok="deleteCalendar"
        >
            Are you sure you want to delete {{ params.data.calendar_name }}?
        </modal>
        <holidays-imports-modal
            :initialValues="initialValues"
            :busy="busy"
            :modalId="editCalendarModalId"
            @submit="updateCalendar"
        />
        <modal
            :id="holidaysModalId"
            :title="params.data.calendar_name"
            @show="fetchHolidays"
            size="lg"
        >
            <grid
                :columnDefs="columnDefs"
                :rowData="rowData"
                :isAutoHeight="true"
            >
                <responsive-button
                    :busy="busy"
                    variant="default"
                    @click="fetchCalendar"
                    :responsiveness="false"
                    >Fetch Holidays</responsive-button
                >
            </grid>
        </modal>
    </div>
</template>

<script>
import api from '../../../api';
import { ADMIN_IMPORT_HOLIDAY_ENDPOINT } from '../../../endpoints';
import modal from '../../generic/modal/modal.vue';
import HolidaysImportsModal from './holidays-imports-modal.vue';
import Grid from '../../generic/grid/grid.vue';
import { formatResponseError } from '../../../utils/api';
import ResponsiveButton from '../../generic/responsive-button/responsive-button.vue';

export default {
    components: {
        modal,
        HolidaysImportsModal,
        Grid,
        ResponsiveButton,
    },
    data() {
        return {
            initialValues: {},
            rowData: [],
            busy: false,
        };
    },
    mounted() {
        this.initialValues = {
            ...this.params.data,
            country: this.params.data.country.id,
        };
    },
    computed: {
        editCalendarModalId() {
            return 'edit-calendar-id' + this.params.data.id;
        },
        deleteCalendarModalId() {
            return 'delete-calendar-id' + this.params.data.id;
        },
        holidaysModalId() {
            return 'holidays-modal-id' + this.params.data.id;
        },
        columnDefs() {
            return [
                {
                    field: 'dtstart',
                    type: 'dateColumn',
                    headerName: 'Start',
                    minWidth: 130,
                },
                {
                    field: 'dtend',
                    type: 'dateColumn',
                    headerName: 'End',
                    minWidth: 130,
                },
                {
                    field: 'summary',
                    headerName: 'Summary',
                    minWidth: 150,
                },
            ];
        },
    },
    methods: {
        showEditModal() {
            this.$bvModal.show(this.editCalendarModalId);
        },
        showDeleteModal() {
            this.$bvModal.show(this.deleteCalendarModalId);
        },
        deleteCalendar() {
            this.params.deleteCalendar &&
                this.params.deleteCalendar(this.params.data.id);
        },
        async updateCalendar(values) {
            this.busy = true;
            this.params.updateCalendar &&
                (await this.params.updateCalendar(
                    values,
                    this.editCalendarModalId
                ));
            this.busy = false;
        },
        async fetchCalendar() {
            try {
                this.busy = true;
                const { data } = await api.get(
                    `${ADMIN_IMPORT_HOLIDAY_ENDPOINT(
                        this.params.data.id
                    )}fetch-calendar/`
                );
                await this.fetchHolidays();
                this.successToast({ text: `Fetched ${data.count} holidays` });
            } catch (e) {
                const { generic } = formatResponseError(e);
                this.errorToast({
                    text: generic || 'Could not fetch holidays.',
                });
            } finally {
                this.busy = false;
            }
        },
        async fetchHolidays() {
            try {
                const { data } = await api.get(
                    `${ADMIN_IMPORT_HOLIDAY_ENDPOINT(
                        this.params.data.id
                    )}holidays/`
                );
                this.rowData = data;
            } catch (e) {
                const { generic } = formatResponseError(e);
                this.errorToast({
                    text: generic || 'Could not fetch holidays.',
                });
            }
        },
    },
};
</script>

<style lang="scss" scoped>
.buttons-wrapper {
    gap: 0.5rem;
}
</style>